import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AddonDiscoveryUtils } from '@atlassian/amkt-addon-discovery';
import { StatsigClient } from '@atlassian/mpac-feature-flags';
import { Source } from '@atlassian/mpac-types';
import { attachGlobalSentryListeners, detachSentryListeners, initSentry, resetSentryClient } from '@atlassian/mpac-utils';
import UFOSegment from '@atlassian/ufo-segment';
import React, { useEffect, useMemo } from 'react';
import { setConfiguration as setReadGridSystemConfig } from 'react-grid-system';
import version from '../../version';
import App from './components/App';
import { createReduxStore } from './Emcee.utils';
import { initSPI } from './services/SPI';
import startEmceeTelemetry from './telemetry/start-telemetry';
const SentryGlobalListeners = _ref => {
  let {
    children,
    onExternalSentryEvent
  } = _ref;
  useEffect(() => {
    if (onExternalSentryEvent) attachGlobalSentryListeners(onExternalSentryEvent);
    return detachSentryListeners;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const Emcee = _ref2 => {
  let {
    spi,
    history: productHistory,
    productVersion,
    applicationConfig,
    mountPath,
    onExternalSentryEvent,
    onRouteTransitionEnd
  } = _ref2;
  const isDev = applicationConfig.environment === 'local' || applicationConfig.environment === 'dev';
  const releaseVersion = "EMCEE_NATIVE_".concat(version).concat(isDev ? '-dev' : '');
  initSPI(spi);
  setReadGridSystemConfig({
    maxScreenClass: 'xl'
  });
  const statsigClient = useMemo(() => new StatsigClient(), []);
  initSentry(_objectSpread(_objectSpread({}, applicationConfig.sentry), {}, {
    releaseVersion,
    productVersion,
    setupGlobalListeners: false
  }));
  const {
    reduxStore
  } = useMemo(() => ({
    reduxStore: createReduxStore()
  }), []);
  const algoliaClient = useMemo(() => AddonDiscoveryUtils.createAlgoliaClient(applicationConfig.algolia), [applicationConfig.algolia]);
  const bootstrapConfig = useMemo(() => _objectSpread(_objectSpread({}, applicationConfig), {}, {
    isInProductConnectModule: false,
    isManageAppRequests: false,
    isManagePromotions: false,
    releaseVersion,
    source: Source.PRODUCT
  }), [applicationConfig, releaseVersion]);
  useEffect(() => {
    startEmceeTelemetry({
      emceeContainer: document.getElementById('emcee'),
      config: applicationConfig.metal,
      SPI: spi,
      emceeVersion: releaseVersion,
      onRouteTransitionEnd
    });
    return () => {
      resetSentryClient();
    };
  }, []);
  return /*#__PURE__*/React.createElement(UFOSegment, {
    name: "emcee-root"
  }, /*#__PURE__*/React.createElement(SentryGlobalListeners, {
    onExternalSentryEvent: onExternalSentryEvent
  }, /*#__PURE__*/React.createElement(App, {
    bootstrapConfig: bootstrapConfig,
    store: reduxStore,
    history: productHistory,
    algoliaClient: algoliaClient,
    onBootstrapConfigChange: () => {
      /*
      [legacy] Was used in Emcee Connect to act upon config changes via the DevTools, has no
      usage in Emcee Native
      */
    },
    mountPath: mountPath,
    statsigClient: statsigClient
  })));
};
export default Emcee;